import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import LazyImage from '../components/LazyImage/LazyImage';
import { LocationIcon, PhoneIcon, EmailIcon, CheckIcon, ArrowLeftIcon, ShareIcon, HeartIcon, HomeIcon, CalendarIcon, BuildingIcon } from '../components/Icons/Icons';
import './ProjectDetail.css';

function ProjectDetail() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showContactForm, setShowContactForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    planInterest: '',
    message: 'I am interested in this housing project. Please provide more details.'
  });

  // Mock project data
  const project = {
    id: 1,
    name: 'Bahria Town Karachi',
    developer: 'Bahria Town (Pvt) Ltd',
    location: 'Super Highway, Karachi',
    city: 'Karachi',
    type: 'Residential',
    priceRange: '45 Lac - 5 Crore',
    totalUnits: '50,000+',
    status: 'Under Development',
    completion: '2026',
    launchDate: 'January 2015',
    totalArea: '45,000 Acres',
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80'
    ],
    description: `Bahria Town Karachi is Pakistan's largest privately developed residential project, spread over 45,000 acres along the Super Highway. This mega project offers a modern lifestyle with world-class amenities and infrastructure.

The development features state-of-the-art planning with wide roads, underground electricity, efficient sewerage systems, and high-speed internet connectivity. The project is designed to accommodate over 50,000 residential units along with commercial areas, educational institutions, and healthcare facilities.

Bahria Town Karachi promises to be a self-sustained city with all modern amenities including shopping malls, cinemas, restaurants, parks, sports facilities, and recreational areas. The project emphasizes security with gated communities and 24/7 surveillance.

Investment opportunities range from residential plots to luxury villas, apartments, and commercial properties. The project offers flexible payment plans making it accessible to a wide range of investors and homebuyers.`,
    amenities: [
      'Gated Community',
      '24/7 Security',
      'Parks & Playgrounds',
      'International Schools',
      'Modern Hospital',
      'Shopping Malls',
      'Cinemas',
      'Sports Complex',
      'Golf Course',
      'Theme Parks',
      'Mosques',
      'Community Centers',
      'Swimming Pools',
      'Gymnasiums',
      'Restaurants',
      'Public Transport',
      'Underground Electricity',
      'Sewerage System',
      'Water Supply',
      'Waste Management'
    ],
    availablePlots: [
      {
        id: 1,
        type: '125 Sq Yards',
        category: 'Residential Plot',
        price: '45 Lac',
        dimensions: '25 x 45 ft',
        status: 'Available',
        possession: 'On Payment'
      },
      {
        id: 2,
        type: '250 Sq Yards',
        category: 'Residential Plot',
        price: '85 Lac',
        dimensions: '35 x 70 ft',
        status: 'Available',
        possession: 'On Payment'
      },
      {
        id: 3,
        type: '500 Sq Yards',
        category: 'Residential Plot',
        price: '1.6 Crore',
        dimensions: '50 x 90 ft',
        status: 'Limited',
        possession: 'On Payment'
      },
      {
        id: 4,
        type: '1000 Sq Yards',
        category: 'Residential Plot',
        price: '3.2 Crore',
        dimensions: '66 x 132 ft',
        status: 'Available',
        possession: 'On Payment'
      },
      {
        id: 5,
        type: 'Villa',
        category: '3 Bedroom Villa',
        price: '2.5 Crore',
        dimensions: '250 Sq Yards',
        status: 'Ready',
        possession: 'Immediate'
      },
      {
        id: 6,
        type: 'Apartment',
        category: '2 Bedroom Apartment',
        price: '95 Lac',
        dimensions: '1200 Sq Ft',
        status: 'Ready',
        possession: 'Immediate'
      }
    ],
    paymentPlan: {
      downPayment: '20%',
      monthlyInstallments: '36 Months',
      possessionCharges: '3%',
      developmentCharges: 'Included'
    },
    nearbyPlaces: [
      { name: 'Jinnah International Airport', distance: '18 km', type: 'Airport' },
      { name: 'Port Qasim', distance: '25 km', type: 'Port' },
      { name: 'Gulistan-e-Johar', distance: '12 km', type: 'Residential Area' },
      { name: 'Malir Cantonment', distance: '8 km', type: 'Cantonment' }
    ],
    developerInfo: {
      name: 'Bahria Town (Pvt) Ltd',
      phone: '+92 21 111 111 111',
      email: 'info@bahriatown.com',
      website: 'www.bahriatown.com',
      description: 'Bahria Town is Pakistan\'s largest private real estate developer with a proven track record of delivering world-class residential and commercial projects.'
    },
    highlights: [
      'Pakistan\'s Largest Private Housing Project',
      'Spread over 45,000 Acres',
      '50,000+ Residential Units',
      'Direct Access from Super Highway',
      'International Standard Infrastructure',
      'Flexible Payment Plans Available',
      'Possession on Payment',
      'High ROI Potential'
    ],
    postedDate: '1 week ago',
    viewCount: 12450
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? project.images.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === project.images.length - 1 ? 0 : prev + 1
    );
  };

  const handleSubmitInquiry = (e) => {
    e.preventDefault();
    console.log('Inquiry submitted:', formData);
    alert('Thank you for your inquiry! Our team will contact you soon.');
    setShowContactForm(false);
    setFormData({
      name: '',
      email: '',
      phone: '',
      planInterest: '',
      message: 'I am interested in this housing project. Please provide more details.'
    });
  };

  return (
    <div className="project-detail-page">
      <Header />

      <div className="project-detail-container">
        <button
          className="back-button"
          onClick={() => window.navigateTo && window.navigateTo('projects')}
        >
          <ArrowLeftIcon size={20} color="#2c3e50" />
          Back to Projects
        </button>

        <div className="project-detail-content">
          <div className="project-main-content">
            <div className="project-gallery">
              <div className="main-image-container">
                <LazyImage
                  src={project.images[currentImageIndex]}
                  alt={project.name}
                  className="main-project-image"
                  aspectRatio="16/9"
                />
                <button className="gallery-btn gallery-prev" onClick={handlePrevImage}>
                  ❮
                </button>
                <button className="gallery-btn gallery-next" onClick={handleNextImage}>
                  ❯
                </button>
                <div className="image-counter">
                  {currentImageIndex + 1} / {project.images.length}
                </div>
              </div>
              <div className="thumbnail-strip">
                {project.images.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  >
                    <LazyImage
                      src={image}
                      alt={`View ${index + 1}`}
                      aspectRatio="4/3"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="project-header">
              <div className="project-title-section">
                <div className="project-title-wrapper">
                  <h1 className="project-title">{project.name}</h1>
                  <div className="project-developer-name">By {project.developer}</div>
                </div>
                <div className="project-actions">
                  <button className="action-btn">
                    <ShareIcon size={20} color="#636e72" />
                  </button>
                  <button className="action-btn">
                    <HeartIcon size={20} color="#636e72" />
                  </button>
                </div>
              </div>
              <div className="project-location">
                <LocationIcon size={18} color="#636e72" />
                <span>{project.location}</span>
              </div>
              <div className="project-meta">
                <span className="project-badge">{project.status}</span>
                <span className="project-badge-type">{project.type}</span>
                <span className="project-meta-text">Posted {project.postedDate}</span>
                <span className="project-meta-text">{project.viewCount} views</span>
              </div>
            </div>

            <div className="project-stats-grid">
              <div className="stat-card">
                <div className="stat-icon">
                  <HomeIcon size={28} color="var(--color-primary)" />
                </div>
                <div className="stat-info">
                  <span className="stat-label">Total Units</span>
                  <span className="stat-value">{project.totalUnits}</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">
                  <BuildingIcon size={28} color="var(--color-primary)" />
                </div>
                <div className="stat-info">
                  <span className="stat-label">Total Area</span>
                  <span className="stat-value">{project.totalArea}</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">
                  <CalendarIcon size={28} color="var(--color-primary)" />
                </div>
                <div className="stat-info">
                  <span className="stat-label">Completion</span>
                  <span className="stat-value">{project.completion}</span>
                </div>
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Project Overview</h2>
              <p className="project-description">{project.description}</p>
            </div>

            <div className="project-section">
              <h2 className="section-title">Key Highlights</h2>
              <div className="highlights-grid">
                {project.highlights.map((highlight, index) => (
                  <div key={index} className="highlight-item">
                    <CheckIcon size={20} color="var(--color-primary)" />
                    <span>{highlight}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Project Details</h2>
              <div className="details-grid">
                <div className="detail-row">
                  <span className="detail-label">Developer</span>
                  <span className="detail-value">{project.developer}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Project Type</span>
                  <span className="detail-value">{project.type}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Launch Date</span>
                  <span className="detail-value">{project.launchDate}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Completion Year</span>
                  <span className="detail-value">{project.completion}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Total Area</span>
                  <span className="detail-value">{project.totalArea}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Price Range</span>
                  <span className="detail-value">PKR {project.priceRange}</span>
                </div>
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Available Plots & Properties</h2>
              <div className="plots-grid">
                {project.availablePlots.map((plot) => (
                  <div
                    key={plot.id}
                    className={`plot-card ${selectedPlan === plot.id ? 'selected' : ''}`}
                    onClick={() => setSelectedPlan(plot.id)}
                  >
                    <div className="plot-header">
                      <h3 className="plot-type">{plot.type}</h3>
                      <span className={`plot-status ${plot.status.toLowerCase()}`}>
                        {plot.status}
                      </span>
                    </div>
                    <div className="plot-category">{plot.category}</div>
                    <div className="plot-price">PKR {plot.price}</div>
                    <div className="plot-details">
                      <div className="plot-detail-item">
                        <span className="plot-detail-label">Size</span>
                        <span className="plot-detail-value">{plot.dimensions}</span>
                      </div>
                      <div className="plot-detail-item">
                        <span className="plot-detail-label">Possession</span>
                        <span className="plot-detail-value">{plot.possession}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Payment Plan</h2>
              <div className="payment-plan-card">
                <div className="payment-item">
                  <span className="payment-label">Down Payment</span>
                  <span className="payment-value">{project.paymentPlan.downPayment}</span>
                </div>
                <div className="payment-item">
                  <span className="payment-label">Monthly Installments</span>
                  <span className="payment-value">{project.paymentPlan.monthlyInstallments}</span>
                </div>
                <div className="payment-item">
                  <span className="payment-label">Possession Charges</span>
                  <span className="payment-value">{project.paymentPlan.possessionCharges}</span>
                </div>
                <div className="payment-item">
                  <span className="payment-label">Development Charges</span>
                  <span className="payment-value">{project.paymentPlan.developmentCharges}</span>
                </div>
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Amenities & Facilities</h2>
              <div className="amenities-grid">
                {project.amenities.map((amenity, index) => (
                  <div key={index} className="amenity-item">
                    <CheckIcon size={18} color="var(--color-primary)" />
                    <span>{amenity}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="project-section">
              <h2 className="section-title">Nearby Landmarks</h2>
              <div className="nearby-places">
                {project.nearbyPlaces.map((place, index) => (
                  <div key={index} className="nearby-item">
                    <div className="nearby-info">
                      <span className="nearby-name">{place.name}</span>
                      <span className="nearby-type">{place.type}</span>
                    </div>
                    <span className="nearby-distance">{place.distance}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="project-sidebar">
            <div className="developer-card">
              <h3 className="developer-title">Developer Information</h3>
              <div className="developer-info">
                <div className="developer-name">{project.developerInfo.name}</div>
                <p className="developer-description">{project.developerInfo.description}</p>
              </div>

              <div className="contact-buttons">
                <a href={`tel:${project.developerInfo.phone}`} className="contact-btn phone-btn">
                  <PhoneIcon size={20} color="#ffffff" />
                  Call Now
                </a>
                <a href={`mailto:${project.developerInfo.email}`} className="contact-btn email-btn">
                  <EmailIcon size={20} color="#ffffff" />
                  Email
                </a>
              </div>

              <button
                className="inquiry-btn"
                onClick={() => setShowContactForm(!showContactForm)}
              >
                Request Information
              </button>

              {showContactForm && (
                <form className="contact-form" onSubmit={handleSubmitInquiry}>
                  <input
                    type="text"
                    placeholder="Your Name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                  <input
                    type="tel"
                    placeholder="Your Phone"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                  <select
                    value={formData.planInterest}
                    onChange={(e) => setFormData({ ...formData, planInterest: e.target.value })}
                    className="plan-select"
                  >
                    <option value="">Select Plan Type</option>
                    {project.availablePlots.map((plot) => (
                      <option key={plot.id} value={plot.type}>
                        {plot.type} - PKR {plot.price}
                      </option>
                    ))}
                  </select>
                  <textarea
                    placeholder="Your Message"
                    rows="4"
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  />
                  <button type="submit" className="submit-btn">Send Inquiry</button>
                </form>
              )}
            </div>

            <div className="investment-tips-card">
              <h3 className="tips-title">Investment Tips</h3>
              <ul className="tips-list">
                <li>Verify NOC (No Objection Certificate) from authorities</li>
                <li>Check the developer's track record and reputation</li>
                <li>Review the master plan and development timeline</li>
                <li>Inspect the location and accessibility</li>
                <li>Compare prices with similar projects</li>
                <li>Read payment plan terms carefully</li>
                <li>Consult with a real estate expert</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ProjectDetail;
